import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
// import './car.css';
import Mpic1 from '@/common/assets/images/Mpic1.jpg';
import Mpic2 from '@/common/assets/images/Mpic2.jpg';
import Mpic3 from '@/common/assets/images/Mpic3.jpg';

import styles from './index.module.less';

export default function Car() {
  // SLIDES
  const SLIDES = [
    { id: 1, src: Mpic1 },
    { id: 2, src: Mpic2 },
    { id: 3, src: Mpic3 }
  ];

  const settings = {
    dots: true,
    infinite: true,
    fade: true,
    speed: 1500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    cssEase: 'linear',
    arrows: false,
    autoplay: true,
    dotsClass: 'slick-dots custom-dots' // Add a custom class to style the dots
  };

  return (
    <div className={styles.car}>
      <Slider {...settings}>
        {SLIDES.map((slide) => (
          <div key={slide.id} className={styles.slider}>
            <img src={slide.src} alt="" className={styles.slideImage} />
            <span className={styles.slidebox} />
          </div>
        ))}
      </Slider>
    </div>
  );
}
